import TableObject from '../Objects/TableObject';
import LinkedTableObject from '../Objects/LinkedTableObject';
import FormObject from '../Objects/FormObject';
import CarouselObject from '../Objects/CarouselObject'

const objects = {
    TableObject,
    LinkedTableObject,
    FormObject,
    CarouselObject
}

export default objects;